import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: string | Date): string {
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(new Date(date));
}

export function formatDateTime(date: string | Date): string {
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date));
}

export function formatCurrency(amount: number, currency = 'GBP'): string {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency,
  }).format(amount);
}

export function getRoleLabel(role: string): string {
  const labels: Record<string, string> = {
    system_admin: 'System Admin',
    group_admin: 'Group Admin',
    group_operator: 'Group Operator',
    venue_admin: 'Venue Admin',
    venue_operator: 'Venue Operator',
    guest: 'Guest',
  };
  return labels[role] || role;
}

export function getStatusColor(status: string): string {
  const colors: Record<string, string> = {
    active: 'bg-green-100 text-green-800',
    paid: 'bg-green-100 text-green-800',
    pending: 'bg-yellow-100 text-yellow-800',
    trialing: 'bg-blue-100 text-blue-800',
    cancelled: 'bg-gray-100 text-gray-800',
    paused: 'bg-gray-100 text-gray-800',
    past_due: 'bg-red-100 text-red-800',
    overdue: 'bg-red-100 text-red-800',
    refunded: 'bg-purple-100 text-purple-800',
    draft: 'bg-gray-100 text-gray-800',
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
}
